var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.name},_vm._l((_vm.legends),function(item){return _c('div',{key:item,class:(_vm.name + "__item")},[_c('span',{class:[item, (_vm.name + "__legend")]}),_vm._v(" "),_c('span',[_vm._v("\n      "+_vm._s(item === 'used'
          ? _vm.$t('module_ios14_quota_used')
          : item === 'reset'
          ? _vm.$t('module_ios14_quota_reset')
          : _vm.$t('module_ios14_quota_left'))+"\n    ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }